<template>
  <div v-if="dialog" style="background-color: black; width: 100%; position: fixed; z-index: 200; opacity: 90%">
      <v-layout row justify-center>
          <v-dialog v-model="dialog"
            persistent max-width="800" max-height="700">      
            <v-card
              style="padding: 15px"
            >
              <v-card-text style="padding:20px; justify-content: center; overflow-y: auto !important; flex-direction: column; align-items: center;">

                <h1 style="font-size:1.5rem;line-height:1.2;margin:0 0 .25rem 0;border-bottom:1px solid #e5e7eb;padding-bottom:.5rem;">
                  AUTORIZAÇÃO PARA TRATAMENTO DE DADOS
                </h1>
                  <div style="color:#4b5563;font-size:.9rem;margin-bottom:1rem;">Última atualização: <strong>04/09/2025</strong></div>

                  <p style="margin:.75rem 0;">Com a(s) finalidade(s) de <strong>registrar seu cadastro</strong> e possibilitar a sua participação na <strong>Campanha do Fla Anjo</strong>, precisamos ter a certeza de que você autorizou o registro e o tratamento de seus dados pessoais (Nome Completo, E-mail, CPF, Telefone, Endereço Completo) em atendimento à Lei Geral de Proteção de Dados, Lei 13.709/2018 e de acordo com as informações descritas a seguir.</p>

                  <p style="margin:.75rem 0;">Também, orientamos e incentivamos a leitura do nosso <strong>Aviso de Privacidade</strong>, onde constam todas as informações sobre como o Flamengo – de modo geral, cuida dos dados pessoais que são recebidos pelo público da Nação.</p>

                  <p style="margin:.75rem 0;">Ressaltamos que esta autorização deve ser fornecida por pessoa natural e <strong>maior de 18 (dezoito) anos</strong> sem qualquer restrição para tomar decisões individualmente. Em caso de cadastro de dados de menores de idade, é necessário a idade do menor quando solicitado e uma autorização formal do responsável legal do menor para que o cadastro seja feito, durante o processo de cadastro.</p>

                  <p style="margin:.75rem 0;">Comunicações específicas sobre proteção de dados pessoais podem ser feitas por meio de um canal exclusivo: o <strong>Portal de Atendimento de Titulares</strong>. Lá, você pode exercer os direitos previstos na Lei: basta abrir um chamado acessando o Portal a partir de uma das opções abaixo:</p>

                  <ul style="padding-left:1.25rem;">
                    <li style="margin:.35rem 0;">Site geral do Flamengo: <a href="https://flamengo.com.br/privacidade" target="_blank" rel="noopener noreferrer" style="color:#b91c1c;text-decoration:none;">https://flamengo.com.br/privacidade</a>, clicar em <em>Portal do Titular</em>.</li>
                    <li style="margin:.35rem 0;">Site de Sócio Torcedor: <a href="https://mengo.com.br/privacidade" target="_blank" rel="noopener noreferrer" style="color:#b91c1c;text-decoration:none;">https://mengo.com.br/privacidade</a>, clicar em <em>Portal do Titular</em>.</li>
                  </ul>

                  <p style="margin:.75rem 0;">Disponibilizamos abaixo um QR Code para o acesso ao Portal diretamente do seu dispositivo móvel.</p>
                  <img src="/images/qrcode-flamengo.png" alt="QR Code para acesso ao Portal do Titular" style="width:150px;height:150px;margin-top:1rem;"/>
                  <div style="background:#f9fafb;border:1px solid #e5e7eb;padding:1rem;border-radius:.75rem;margin-top:1rem;">
                    <p style="margin:.5rem 0;">Por fim, tendo em vista que buscamos esclarecer todas as informações relevantes neste documento, nosso time de colaboradores entenderá que, ao clicar em <span style="font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,'Liberation Mono','Courier New',monospace;background:#111827;color:#fff;padding:.15rem .35rem;border-radius:.35rem;font-size:.85rem;">AUTORIZO O TRATAMENTO DOS MEUS DADOS</span>, você consentiu de forma livre, inequívoca, esclarecida e expressa com o tratamento que daremos aos seus dados.</p>
                  </div>

                  <h2 style="font-size:1.25rem;margin-top:2rem;margin-bottom:.75rem;">Finalidades de uso dos dados pessoais (FLAMENGO E PARCEIROS)</h2>

                  <p style="margin:.75rem 0;"><strong>Coletamos os dados abaixo para/porque:</strong></p>
                  <ul style="padding-left:1.25rem;">
                    <li><strong>Nome</strong> — Informação exigida pelo Ministério dos Esportes por obrigação da Lei 11.439/2006.</li>
                    <li><strong>CPF</strong> — Informação exigida pelo Ministério dos Esportes por obrigação da Lei 11.439/2006.</li>
                    <li><strong>E-mail</strong> — para comunicação sobre o programa, cronogramas, envio de agradecimentos e acompanhamento dos projetos apoiados.</li>
                    <li><strong>Endereço</strong> — Informação exigida pelo Ministério dos Esportes.</li>
                    <li><strong>Telefone</strong> — para eventual contato sobre assuntos relacionados à campanha Fla Anjo.</li>
                  </ul>

                  <p style="margin:.75rem 0;">Os dados acima são os mínimos necessários para viabilizar a sua experiência. Uma vez mantidos os seus dados em nossas bases, eventualmente, você poderá receber comunicações sobre o Flamengo ou dos nossos parceiros comerciais, a saber:</p>

                  <ul style="padding-left:1.25rem;">
                    <li><strong>Abrace uma Causa Gestão e Serviço Ltda.</strong> — plataforma gestora da campanha.</li>
                    <li><strong>Ministério do Esporte</strong> — responsável pelo envio das informações de doação à Receita Federal do Brasil.</li>
                    <li><strong>Receita Federal do Brasil</strong> — responsável por conceder e gerir o benefício fiscal.</li>
                    <li><strong>Asaas Gestão Financeira Instituição de Pagamentos S.A.</strong> — responsável pela gestão sistêmica de pagamentos.</li>
                  </ul>

                  <h2 style="font-size:1.25rem;margin-top:2rem;margin-bottom:.75rem;">Forma e duração do tratamento</h2>
                  <p style="margin:.75rem 0;">Tendo em vista que nossa intenção principal é garantir sua segurança contábil e jurídica, pretendemos manter seus dados em nossas bases por <strong>4 anos</strong>. Porém, a qualquer momento, conforme sua vontade, é possível exercer seus direitos e, por exemplo, contestar, tirar dúvidas e até solicitar a exclusão de seus dados de nossas bases. Para isto, basta acessar o <strong>Portal do Titular</strong>.</p>

                  <h2 style="font-size:1.25rem;margin-top:2rem;margin-bottom:.75rem;">Direitos do titular (LGPD)</h2>
                  <p style="margin:.75rem 0;">Conheça os direitos de cada titular garantidos pela Lei Geral de Proteção de Dados: receber informações sobre quais dos seus dados coletamos, alterar e corrigir seus dados, negar ou revogar consentimento anteriormente dado, solicitar anonimização, bloqueio ou eliminação de dados, solicitar portabilidade.</p>
                  <p style="font-size:.95rem;color:#4b5563;"><em>Não esperamos jamais que mude de time. Mas, se algum dia isto acontecer, vamos cumprir com a nossa parte!</em></p>

                  <h2 style="font-size:1.25rem;margin-top:2rem;margin-bottom:.75rem;">Contato do Encarregado pelo tratamento de dados pessoais (DPO)</h2>
                  <p style="margin:.75rem 0;">A DPO responsável é <strong>Liliane Ferreira</strong>. Para contato, utilize o <strong>Portal do Titular</strong> ou envie um e-mail para <a href="mailto:privacidade@flamengo.com.br" style="color:#b91c1c;text-decoration:none;">privacidade@flamengo.com.br</a>.</p>
                  <p style="font-size:.95rem;color:#4b5563;">Para exercer seus direitos previstos na LGPD, utilize exclusivamente o Portal do Titular.</p>

                  <h2 style="font-size:1.25rem;margin-top:2rem;margin-bottom:.75rem;">Lei Aplicável e Foro</h2>
                  <p style="margin:.75rem 0;">Para quaisquer conflitos de ordem legal que possam surgir após o seu ingresso no cadastro do Fla Anjo, aplica-se a legislação brasileira e fica eleito o foro da <strong>Comarca do Rio de Janeiro/RJ</strong>, com renúncia a qualquer outro.</p>


              </v-card-text>
              <v-card-actions class="pa-0 p-2" style="background-color: white !important;">
                <v-btn flat
                  round
                  color="white"
                  class="btn-primary flex-inherit px-5 ml-auto"
                  style="margin: 20px;"
                  large 
                  @click="close">
                Concordo
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

      </div>
</template>

<script type="plain/text">
// Services
import CampaignService from "@/scripts/services/campaign.service";

//VUEX
import { mapGetters, mapActions } from "vuex";

export default {
  props: ['dialog'],
  data() {
    return {
      campaignService: new CampaignService(),
      showLGPDTerm: false,
    };
  },
  computed: {
    ...mapGetters([
      'logged',
      'userProfile',
      'campaignLandingPageConfig',
    ]),
  },
  created() {
    this.setLandingPageConfig();
  },
  methods: {
    ...mapActions([
      'setLandingPageConfig'
    ]),
    close() {
      this.$emit('close');
    },
  },
}
</script>